module.exports = __webpack_public_path__ + "img/1.9c2d6339.jpg";